import { render } from "./FoodcycleSolutionDetails.vue?vue&type=template&id=9217042e&scoped=true"
import script from "./FoodcycleSolutionDetails.vue?vue&type=script&lang=js"
export * from "./FoodcycleSolutionDetails.vue?vue&type=script&lang=js"

import "./FoodcycleSolutionDetails.vue?vue&type=style&index=0&id=9217042e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9217042e"]])

export default __exports__